// extracted by mini-css-extract-plugin
module.exports = {"children":"PriceProgressBar_children__f3cKm"};